export enum TutorMode {
  PREVIEW = "preview",
  PUBLIC = "public",
}
